(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["707-hero"] && !Shopify.designMode) return;
  try {
    
function setupNanaHeroes(){document.querySelectorAll('.nana-hero').forEach(hero=>{if(hero.dataset.ready)return;hero.dataset.ready='true';const rail=hero.querySelector('.nana-slides');const dots=[...hero.querySelectorAll('.nana-dot')];dots.forEach((dot,i)=>dot.addEventListener('click',()=>rail.scrollTo({left:rail.clientWidth*i,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));rail.addEventListener('scroll',()=>{const active=Math.round(rail.scrollLeft/rail.clientWidth);dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===active)));},{passive:true});hero.addEventListener('shopify:block:select',event=>{const selected=event.target.closest('.nana-slide');if(selected)rail.scrollTo({left:selected.offsetLeft,behavior:'instant'});});});}setupNanaHeroes();document.addEventListener('shopify:section:load',setupNanaHeroes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["707-photo-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-photo-strip')) {
    customElements.define('nana-photo-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const viewport = this.querySelector('.nana-photo-strip__viewport');
        const group = this.querySelector('.nana-photo-strip__group');
        const button = this.querySelector('.nana-photo-strip__toggle');
        if (!viewport || !group || !group.children.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        group.after(clone);
        this.clone = clone;
        let paused = this.dataset.autoplay !== 'true' || reduced.matches || !!window.Shopify?.designMode;
        let visible = false, hovering = false, touching = false, focused = false;
        let distance = 0, position = viewport.scrollLeft, previous = 0, waitUntil = 0;
        const measure = () => {
          distance = group.getBoundingClientRect().width + parseFloat(getComputedStyle(group.parentElement).gap || '0');
          position = viewport.scrollLeft;
        };
        const updateButton = () => {
          button.hidden = false;
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        };
        const hold = () => { waitUntil = performance.now() + 2500; position = viewport.scrollLeft; };
        viewport.addEventListener('pointerdown', () => { touching = true; hold(); }, { signal, passive: true });
        const release = () => { if (touching) { touching = false; hold(); } };
        window.addEventListener('pointerup', release, { signal, passive: true });
        window.addEventListener('pointercancel', release, { signal, passive: true });
        viewport.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovering = true; }, { signal });
        viewport.addEventListener('pointerleave', () => { hovering = false; }, { signal });
        viewport.addEventListener('wheel', hold, { signal, passive: true });
        viewport.addEventListener('keydown', hold, { signal });
        viewport.addEventListener('focusin', () => { focused = true; }, { signal });
        viewport.addEventListener('focusout', () => { focused = false; hold(); }, { signal });
        button.addEventListener('click', () => { paused = !paused; position = viewport.scrollLeft; updateButton(); }, { signal });
        reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; updateButton(); } }, { signal });
        this.addEventListener('shopify:block:select', e => {
          paused = true;
          updateButton();
          const photo = e.target.closest('.nana-photo-strip__photo');
          if (photo) viewport.scrollLeft = photo.getBoundingClientRect().left - group.getBoundingClientRect().left;
        }, { signal });
        this.resizeObserver = new ResizeObserver(measure);
        this.resizeObserver.observe(group);
        const frame = now => {
          const elapsed = previous ? Math.min(now - previous, 40) : 0;
          previous = now;
          if (visible && !document.hidden && !paused && !hovering && !touching && !focused && now > waitUntil && distance > viewport.clientWidth) {
            position = (position + elapsed * 0.025) % distance;
            viewport.scrollLeft = position;
          } else {
            position = viewport.scrollLeft;
          }
          if (visible) this.frameId = requestAnimationFrame(frame);
          else this.frameId = null;
        };
        this.intersectionObserver = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          if (visible && !this.frameId) { previous = 0; this.frameId = requestAnimationFrame(frame); }
        }, { threshold: 0 });
        this.intersectionObserver.observe(this);
        measure();
        updateButton();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.frameId);
        this.frameId = null;
        this.clone?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["707-welcome-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nana-welcome')) {
  customElements.define('nana-welcome', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      const query = new URLSearchParams(location.search);
      this.preview = this.dataset.designMode === 'true' || (query.has('preview_theme_id') && query.get('nana_welcome_preview') === '1');
      this.storageKey = this.preview ? '707-welcome-preview-v1' : '707-welcome-v1';
      this.enabled = this.dataset.enabled === 'true';
      this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.form.addEventListener('submit', event => {
        if (!this.enabled || this.preview || !this.form.checkValidity()) {
          event.preventDefault();
          return;
        }
        this.remember({ pending: true });
      }, options);
      if (!this.enabled || this.preview) this.form.querySelectorAll('input, button[type=submit]').forEach(input => { input.disabled = true; });
      if (!this.enabled && !this.preview) return;
      const success = this.querySelector('[data-welcome-success]');
      const error = this.querySelector('[data-welcome-error]');
      if (success || error) {
        if (this.readState().pending && !this.preview) {
          this.remember({ pending: false, ...(success ? { subscribed: true } : {}) });
          this.openPopup(true);
        }
        return;
      }
      if (this.hasSeen()) return;
      this.timer = setTimeout(() => this.openPopup(), this.preview ? 300 : Number(this.dataset.delay || 8) * 1000);
    }
    hasSeen() {
      const state = this.readState();
      return Boolean(state.shown || state.subscribed || state.until);
    }
    openPopup(formResponse = false) {
      if (!this.isConnected || this.dialog.open || (!formResponse && this.hasSeen())) return;
      if (!formResponse && (document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select'))) return;
      this.dialog.showModal();
      this.remember({ shown: true });
    }
    readState() {
      for (const type of ['localStorage', 'sessionStorage']) {
        try {
          const raw = window[type].getItem(this.storageKey);
          if (raw) {
            const state = JSON.parse(raw);
            if (state && typeof state === 'object') return state;
          }
        } catch {}
      }
      return window.nanaWelcomeState?.[this.storageKey] || {};
    }
    remember(next) {
      const state = { ...this.readState(), ...next };
      window.nanaWelcomeState ||= {};
      window.nanaWelcomeState[this.storageKey] = state;
      for (const type of ['localStorage', 'sessionStorage']) {
        try { window[type].setItem(this.storageKey, JSON.stringify(state)); } catch {}
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
